import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import AppLayout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Activities from './pages/Activities';
import ActivityForm from './pages/Activities/ActivityForm';
import Registrations from './pages/Registrations';
import Members from './pages/Members';
import Banners from './pages/Banners';
import System from './pages/System';

// 路由守卫
function PrivateRoute({ children }) {
  const token = localStorage.getItem('admin_token');
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <ConfigProvider locale={zhCN} theme={{ token: { colorPrimary: '#2E7D32' } }}>
      <BrowserRouter basename="/ops">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><AppLayout /></PrivateRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="activities" element={<Activities />} />
            <Route path="activities/create" element={<ActivityForm />} />
            <Route path="activities/:id/edit" element={<ActivityForm />} />
            <Route path="registrations/:activityId" element={<Registrations />} />
            <Route path="members" element={<Members />} />
            <Route path="banners" element={<Banners />} />
            <Route path="system" element={<System />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
